import { processAndFormatPath, findNode } from '@/view/pages/components/index.js'

export default {
    loginBegin(state) {
        state.loading = true;
    },
    loginSuccess(state, data,) {
        state.loading = false;
        state.login = data.login;
        state.super_login = data.super_login;
    },

    loginErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    logoutBegin(state) {
        state.loading = true;
    },

    logoutSuccess(state, data) {
        state.loading = false;
        state.login = data;
        state.super_login = false;
    },

    logoutErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    menuData(state, data) {
        state.menuData = data;
    },
    someMutation(state, lang) {
        state.site_lang = lang;
    },
    setCollapsed(state, payload) {
        state.collapsed = payload;

    },
    superToken(state, payload) {
        state.super_token = payload;
    },
    siteListFnc(state, payload) {
        state.site_list = payload;
    },
    alearTabsList(state) {
        // 主要适用于没有退出，但是token值变化的情况下，设置默认值，清除页签
        state.tabsList = []
    },
    SET_REFRESH_FLAG(state, path) {
        state.refreshFlags[path] = Date.now() // 用时间戳作为标记，确保每次变化
    },
    // tab页签删除左侧
    leftDelTab(state, payload) {
        const targetIndex = payload.data.findIndex(item => item.path === payload.path) // 修改：使用 path
        if (targetIndex === -1) return
        state.tabsList = [
            payload.data[0],
            ...payload.data.slice(targetIndex)
        ]
    },

    // tab页签删除右侧
    rightDelTab(state, payload) {
        const targetIndex = payload.data.findIndex(item => item.path === payload.path) // 修改：使用 path
        if (targetIndex === -1) return
        state.tabsList = payload.data.slice(0, targetIndex + 1)
    },

    // tab页签删除其他
    otherDelTab(state, payload) {
        state.tabsList = [
            payload.data[0],
            ...payload.data.filter(item => item.path === payload.path) // 修改：使用 path
        ]
    },
    // 只保留首页，其余全部删除
    lastTabsList(state) {
        // 主要适用于没有退出，但是token值变化的情况下，设置默认值，清除页签
        state.tabsList = [{ path: "/", title: "", id: "网站概况", name: "网站概况", meta: { auth: false } }]
    },   
    siteDataFnc(state, payload) {
        state.siteData = payload;
    },
    ADD_TABS_LIST(state, payload) {
        // 根据path判断是否已存在相同的标签页
        if (state.tabsList.some(v => v.path === payload.path)) return
        
        const camelCaseTitle = processAndFormatPath(payload.path);
        if (payload.meta.true_id) {
            const menuItem = findNode(state.menuData, payload.meta.true_id);
            if (menuItem && menuItem.menu_type == 2) {
                payload.menu_type = 2; // 添加menu_type属性
            }
        }
        
        // 从路由参数中获取ID并构建标签页名称
        let tabName = payload.name;
        
        // 根据payload.name（实际是菜单项ID）在menuData中查找对应的菜单项名称
        const menuItem = findNode(state.menuData, payload.name);
        if (menuItem) {
            tabName = menuItem.name; // 使用菜单项的实际名称
        }
        
        const pathParts = payload.path.split('/');
        // 寻找ID部分，通常在路径的最后部分
        let idValue = '';
        for (let i = pathParts.length - 1; i >= 0; i--) {
            const part = pathParts[i];
            if (part && !isNaN(part) && part.trim() !== '') {
                idValue = part;
                break;
            }
        }
        // 如果找到了数字ID且路径包含编辑关键词，则组合name和id
        if (idValue && (payload.path.includes('/article/edit/'))) {
            tabName = `${tabName}_${idValue}`; // 使用菜单项名称而不是payload.name
        }
        state.tabsList.push({
            path: payload.path,
            title: camelCaseTitle,
            id: payload.name, // 保持原来的ID（即菜单项ID）
            name: tabName, // 使用拼接后的名称
            meta: { ...payload.meta },
        });
        
    },
    SET_TABS_LIST(state, path) {
        state.activeTab = path
    },
    DEL_TABS_LIST(state, payload) {
        state.tabsList = state.tabsList.filter(tab => tab.path !== payload.path);
        
    }
};

